import { Injectable } from '@angular/core';

@Injectable()
export class StorageConfigProvider {

    private appStorageKeyPrefix = 'cnes';

    private _userStorageKeyPrefix: string;

    get userStorageKeyPrefix(): string {
        return this._userStorageKeyPrefix;
    }

    set userStorageKeyPrefix(data: string) {
        this._userStorageKeyPrefix = `${this.appStorageKeyPrefix}-${data}`;
    }

    get usuarioLogado(): string {
        return `${this.appStorageKeyPrefix}-usuario-logado`;
    }

    get rascunhosEstabelecimento(): string {
        return `${this.userStorageKeyPrefix}-rascunhos-estabelecimento`;
    }

    get edicaoEntidadeEstabelecimento(): string {
        return `${this.userStorageKeyPrefix}-rascunhos-estabelecimento-entidade-`;
    }

    get edicaoEstabelecimentoIdentificacao(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-identificacao-`;
    }

    get edicaoEstabelecimentoIdentificacaoEnderecoComplementar(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-identificacao-endereco-complementar-`;
    }

    get edicaoEstabelecimentoComplementar(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-complementar-`;
    }

    get edicaoEstabelecimentoCaracterizacao(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-caracterizacao-`;
    }

    get edicaoEstabelecimentoProfissionais(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-profissionais-`;
    }

    get edicaoEstabelecimentoEquipes(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-equipes-`;
    }

    get edicaoEstabelecimentoRecursosFisicos(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-recursos-fisicos`;
    }

    get edicaoEstabelecimentoInstalacoesRecursosFisicos(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-instalacoes-recursos-fisicos-`;
    }

    get edicaoEstabelecimentoLeitosRecursosFisicos(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-leitos-recursos-fisicos-`;
    }

    get edicaoEstabelecimentoEquipamentosRecursosFisicos(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-equipamentos-recursos-fisicos-`;
    }

    get edicaoEstabelecimentoCarecterizacaoServicos(): string {
        return `${this.userStorageKeyPrefix}-edicao-estabelecimento-caracterizacao-servicos-`;
    }

    get painelEstabelecimentoIdentificacao(): string {
        return `${this.userStorageKeyPrefix}-painel-estabelecimento-`
    }

}
